import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

import {
  getFlattenedGroupingUsers,
  parseUserIdsParam,
} from "../utils/myTaskUtils";

export function useGroupingBoardsState() {
  const [searchParams] = useSearchParams();
  const groupingUser = useSelector(
    (state) => state.groupingUser.allocationUsers
  );

  const users = useMemo(
    () => getFlattenedGroupingUsers(groupingUser),
    [groupingUser]
  );

  const usersFromParams = useMemo(
    () => parseUserIdsParam(searchParams.get("uid")),
    [searchParams]
  );

  return {
    isGroupedByTeam: searchParams.get("switch") === "true",
    users,
    usersFromParams,
  };
}
